export default {"src":"/_next/static/media/IconographySet_Four Payments.09660b49.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};